const headerStyle = {
  fontFamily: "Poppins",
  fontSize: "14px",
  fontWeight: 600,
  lineHeight: "15px",
  textAlign: "left",
  textUnderlinePosition: "from-font",
  textDecorationSkipInk: "none",
  background: "#7593F2",
  color: "#FFFFFF",
};
const cellStyles = {
  fontFamily: "Poppins",
  fontSize: "12px",
  fontWeight: 500,
  lineHeight: "13px",
  textAlign: "left",
  textUnderlinePosition: "from-font",
  textDecorationSkipInk: "none",
};

export const applicationOverviewTableColumns = [
  {
    key: "check",
    display_name: "",
    cellStyles: { ...cellStyles },
    headerStyles: { ...headerStyle, width: "5%" },
    _config: {
      type: "checkbox",
      displayInColumn: false,
    },
  },
  {
    key: "name",
    display_name: "Application Name",
    cellStyles: { ...cellStyles },
    headerStyles: headerStyle,
  },
  {
    key: "paradigmType",
    display_name: "Type",
    cellStyles: { ...cellStyles },
    headerStyles: headerStyle,
  },
  {
    key: "browser",
    display_name: "Browser",
    cellStyles: { ...cellStyles },
    headerStyles: { ...headerStyle },
  },
  {
    key: "mobilePlatform",
    display_name: "Platform",
    cellStyles: { ...cellStyles },
    headerStyles: { ...headerStyle },
  },
  {
    key: "mobileFileName",
    display_name: "APK File",
    cellStyles: { ...cellStyles },
    headerStyles: { ...headerStyle },
  },
  {
    key: "edit",
    display_name: "",
    cellStyles: { "font-size": "13px" },
    headerStyles: { ...headerStyle, width: "6%" },
    _config: {
      displayInColumn: false,
      type: "svg",
      value: "../../../../assets/images/table/table-item-edit.svg",
      isClickable: "true",
    },
  },
];

export const applicationDetail = [
  {
    key: "check",
    display_name: "",
    cellStyles: { ...cellStyles },
    headerStyles: { ...headerStyle, width: "5%" },
    _config: {
      type: "checkbox",
      displayInColumn: false,
    },
  },
  {
    key: "name",
    display_name: "Page Name",
    cellStyles: { ...cellStyles },
    headerStyles: { ...headerStyle, width: "20%" },
  },
  {
    key: "url",
    display_name: "URL",
    cellStyles: { ...cellStyles },
    headerStyles: headerStyle,
  },
  {
    key: "edit",
    display_name: "",
    cellStyles: { "font-size": "13px" },
    headerStyles: { ...headerStyle, width: "6%" },
    _config: {
      displayInColumn: false,
      type: "svg",
      value: "../../../../assets/images/table/table-item-edit.svg",
      isClickable: "true",
    },
  },
];

export const mobileApplicationDetail = [
  {
    key: "check",
    display_name: "",
    cellStyles: { ...cellStyles },
    headerStyles: { ...headerStyle, width: "5%" },
    _config: {
      type: "checkbox",
      displayInColumn: false,
    },
  },
  {
    key: "name",
    display_name: "Page Name",
    cellStyles: { ...cellStyles },
    headerStyles: { ...headerStyle, width: "60%" },
  },
  {
    key: "edit",
    display_name: "",
    cellStyles: { "font-size": "13px" },
    headerStyles: { ...headerStyle, width: "6%" },
    _config: {
      displayInColumn: false,
      type: "svg",
      value: "../../../../assets/images/table/table-item-edit.svg",
      isClickable: "true",
    },
  },
];

